module.exports = __webpack_public_path__ + "img/tetrapack.6167e79b.jpg";